import { Anchor, Card, Container, List, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

/** What the app is, in the words a parent asks about it. */
export function HelpPage() {
  return (
    <Container size="sm" py="xl">
      <Stack>
        <Title order={2}>Wie Sokrates arbeitet</Title>

        <Card withBorder padding="lg">
          <Stack gap="sm">
            <Text fw={600}>Sokrates gibt keine Lösungen.</Text>
            <Text size="sm" c="dimmed">
              Das ist kein Sparmodus, sondern der ganze Zweck. Er stellt Fragen, bis dein Kind
              selbst darauf kommt — und wenn es feststeckt, werden die Fragen kleiner, nicht
              beantwortender.
            </Text>
          </Stack>
        </Card>

        <Card withBorder padding="lg">
          <Stack gap="sm">
            <Text fw={600}>So läuft eine Sitzung</Text>
            <List size="sm" spacing="xs">
              <List.Item>Kind auswählen und die vierstellige PIN eingeben.</List.Item>
              <List.Item>
                Das Arbeitsblatt fotografieren — oder einfach eintippen, woran es hakt.
              </List.Item>
              <List.Item>
                Antworten, tippend oder sprechend. Sokrates fragt weiter.
              </List.Item>
            </List>
          </Stack>
        </Card>

        <Card withBorder padding="lg">
          <Stack gap="sm">
            <Text fw={600}>Was gespeichert wird</Text>
            <Text size="sm" c="dimmed">
              Das Foto des Arbeitsblatts bleibt nur, solange die Sitzung läuft, und wird danach
              gelöscht. Der Gesprächsverlauf bleibt — er ist der Lernverlauf, den du im
              Eltern-Modus siehst.
            </Text>
          </Stack>
        </Card>

        <Anchor component={Link} to="/">
          Zurück
        </Anchor>
      </Stack>
    </Container>
  );
}
